export default __webpack_public_path__ + "static/media/trackerLife.505baa76.png";